// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(appBaseURL)
// ** START:  
export const getProdSvcUOMListF01Data = createAsyncThunk('appProduct/getProdSvcUOMListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller = '' } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        /* Note state.uOM is defined in 
        index.js or a js file 
        calling 
        const store = useSelector(state => state.uOM.uOMListF01) */
        if (!state.prodSvcUOM.prodSvcUOMListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/product/get-prodsvc-uom-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getProdSvcUOMListF01Data', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Product/getProdSvcUOMListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.prodSvcUOM.prodSvcUOMListF01.allData
            tempIsDataLoaded = state.prodSvcUOM.prodSvcUOMListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:
         
        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            let aValue, bValue
        
            // Handle cases where sortColumn might specify a nested property
            if (sortColumn.includes('.')) {
                const splitColumn = sortColumn.split('.')
                aValue = a[splitColumn[0]] ? a[splitColumn[0]][splitColumn[1]] : null
                bValue = b[splitColumn[0]] ? b[splitColumn[0]][splitColumn[1]] : null
            } else {
                aValue = a[sortColumn]
                bValue = b[sortColumn]
            }
        
            // Handling nulls - nulls will sort to the end
            if (aValue === null) return 1
            if (bValue === null) return -1
            if (aValue === null && bValue === null) return 0
        
            // General comparison
            return aValue < bValue ? -1 : aValue > bValue ? 1 : 0
        })
        
        // Determine the sorting direction
        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            prodSvcUOM => { 
                return ((
                // uOM._.toLowerCase().includes(queryLowered) ||
                // uOM._.toLowerCase().includes(queryLowered) ||
                prodSvcUOM.prodSvcUOM.toLowerCase().includes(queryLowered))
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const prodSvcUOMListF01Slice = createSlice({
    name: 'prodSvcUOMListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getProdSvcUOMListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcUOMListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcUOMListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProdSvcUOMListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// ** START:  
export const getProdSvcUOMRowF01Data = createAsyncThunk('appProduct/getProdSvcUOMRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/get-prodsvc-uom-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProdSvcUOMRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getProdSvcUOMRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const prodSvcUOMRowF01Slice = createSlice({
    name: 'prodSvcUOMRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getProdSvcUOMRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getProdSvcUOMRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getProdSvcUOMRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getProdSvcUOMRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateProdSvcUOM = createAsyncThunk('appProduct/updateProdSvcUOM', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/update-prodsvc-uom/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        // console.log(process.env.NODE_ENV)
        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcUOMUpdateSlice = createSlice({
    name: 'prodSvcUOMUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateProdSvcUOM.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateProdSvcUOM.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateProdSvcUOM.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateProdSvcUOM:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createProdSvcUOM = createAsyncThunk('appProduct/createProdSvcUOM', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/create-prodsvc-uom`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcUOMCreateSlice = createSlice({
    name: 'prodSvcUOMCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createProdSvcUOM.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createProdSvcUOM:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createProdSvcUOM.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createProdSvcUOM.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createProdSvcUOM\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteProdSvcUOM = createAsyncThunk('appProduct/deleteProdSvcUOM', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/delete-prodsvc-uom/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcUOMDeleteSlice = createSlice({
    name: 'prodSvcUOMDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteProdSvcUOM.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProdSvcUOM.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProdSvcUOM.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteProdSvcUOM:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Used for dropdown menu:
export const getProdSvcUOMListF02Data = createAsyncThunk('appProduct/getProdSvcUOMListF02Data', async (params, thunkAPI) => {
    try {

        const response = await fetch(`${appBaseURL}/product/get-prodsvc-uom-list-f02`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProdSvcUOMListF02Data', response.statusText)
        }

        const data = await response.json()

        return {
            params,
            data
        }

    } catch (error) {
        console.log(error.message)
        return thunkAPI.rejectWithValue(error.message)  
    }

})

export const prodSvcUOMListF02Slice = createSlice({
    name: 'prodSvcUOMListF02Slice',
    initialState: {
        params: {},
        data: [],
        total: 0,
        loading: false, 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    extraReducers: builder => {
    builder.addCase(getProdSvcUOMListF02Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.loading = false
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcUOMListF02Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcUOMListF02Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProdSvcUOMListF02Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// Export actions
export const { setIsDataLoaded } = prodSvcUOMListF01Slice.actions
export const { resetCreateState } = prodSvcUOMCreateSlice.actions

// Combine reducers
const prodSvcUOMReducer = combineReducers({
    prodSvcUOMListF01: prodSvcUOMListF01Slice.reducer,
    prodSvcUOMListF02: prodSvcUOMListF02Slice.reducer,
    prodSvcUOMRowF01: prodSvcUOMRowF01Slice.reducer,
    prodSvcUOMCreate: prodSvcUOMCreateSlice.reducer,
    prodSvcUOMUpdate: prodSvcUOMUpdateSlice.reducer,
    prodSvcUOMDelete: prodSvcUOMDeleteSlice.reducer
})


export default prodSvcUOMReducer